import mutations from './mutations';
import actions from './actions';

const defaultState = () => {
  return {};
};

const Samples = {
  namespaced: true,
  state: defaultState,
  getters: {},
  mutations,
  actions,
};

export { Samples, defaultState };
